import React, { createContext, ReactNode, useState, useContext, useEffect } from 'react';
import { UserPreferences } from '../types';

interface PreferencesContext {
  preferences: UserPreferences;
  updatePreferences: (newPreference: Partial<UserPreferences>) => void;
}

const initialState: PreferencesContext = {
  preferences: {
    theme: 'system',
    autoUpdate: false,
    showSaveDialog: true,
  },
  updatePreferences: (_newPreference: Partial<UserPreferences>) => {},
};

const PreferencesContext = createContext(initialState);

interface PreferencesProvider {
  children: ReactNode;
}

export const PreferencesProvider = ({ children }: PreferencesProvider) => {
  const [preferences, setPreferences] = useState<UserPreferences>(initialState.preferences);

  useEffect(() => {
    const storedPreferences = localStorage.getItem('preferences');
    if (storedPreferences) {
      setPreferences(JSON.parse(storedPreferences));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('preferences', JSON.stringify(preferences));
  }, [preferences]);

  const updatePreferences = (newPreference: Partial<UserPreferences>) => {
    setPreferences(preferences => ({ ...preferences, ...newPreference }));
  };

  return (
    <PreferencesContext.Provider value={{ updatePreferences, preferences }}>
      {children}
    </PreferencesContext.Provider>
  );
};

export const usePreferences = () => useContext(PreferencesContext);
